var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagIcon = function SvgFlagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.462 1.398a.51.51 0 0 0-.924 0L1.109 18.082a.6.6 0 0 0-.061.26c0 .305.234.553.523.553H18.43q.13-.001.246-.065a.57.57 0 0 0 .216-.748zm.924-.52 8.429 16.684c.408.808.118 1.812-.647 2.243a1.5 1.5 0 0 1-.74.195H1.572c-.867 0-1.57-.742-1.57-1.658 0-.272.063-.54.184-.78L8.613.878C9.022.07 9.973-.236 10.74.195c.275.155.5.393.647.683m-.931 13.465h-.91l-.234-7.429h1.378zM10 17.39c-.44 0-.806-.402-.806-.85 0-.465.366-.852.806-.852s.807.387.807.851c0 .449-.367.851-.807.851"
  })));
};
export default SvgFlagIcon;